import { render, staticRenderFns } from "./member_tpl.vue?vue&type=template&id=04382632&scoped=true&"
import script from "./member_tpl.vue?vue&type=script&lang=js&"
export * from "./member_tpl.vue?vue&type=script&lang=js&"
import style0 from "./member_tpl.vue?vue&type=style&index=0&id=04382632&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04382632",
  null
  
)

export default component.exports